import { useState } from "react";

export default function usePagination(initial = 0, initialRows = 25) {
  const [total, setTotal] = useState(initial);
  const [page, setPage] = useState(initial);
  const [rowsPerPage, setRowsPerPage] = useState(initialRows);

  return {
    total,
    setTotal,
    page,
    rowsPerPage,
    setPage,
    setRowsPerPage,
  };
}